import { render } from "./SystemLegalDocumentDetail.vue?vue&type=template&id=da8a64da&scoped=true"
import script from "./SystemLegalDocumentDetail.vue?vue&type=script&lang=js"
export * from "./SystemLegalDocumentDetail.vue?vue&type=script&lang=js"

import "./SystemLegalDocumentDetail.vue?vue&type=style&index=0&id=da8a64da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da8a64da"]])

export default __exports__